import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

import { Suspendable } from '@components';
import { ROUTES } from '@constants';

const PlayerCampaigns = Suspendable(
  lazy(() =>
    import('@modules/playerCampaigns/controller/PlayerCampaignsController').then(
      (module) => ({
        default: module.default,
      })
    )
  )
);

const PlayerCampaignDetails = Suspendable(
  lazy(() =>
    import('@modules/playerCampaigns/submodules/PlayerCampaignDetails/controller/PlayerCampaignDetailsController').then(
      (module) => ({
        default: module.default,
      })
    )
  )
);

export const PlayerCampaignsRoutes: RouteObject[] = [
  {
    element: <PlayerCampaigns />,
    path: ROUTES.PLAYER_CAMPAIGNS.ROOT,
  },
  {
    element: <PlayerCampaignDetails />,
    path: ROUTES.PLAYER_CAMPAIGNS.DETAILS,
  },
];
